const storage = localStorage;

export default storage;
